export const SET_CUSTOMER_TICKETS = "SET_CUSTOMER_TICKETS";
export const ADD_CUSTOMER_TICKET = "ADD_CUSTOMER_TICKET";
export const ADD_SHARE_TICKET_REQUEST = "ADD_SHARE_TICKET_REQUEST";
export const SET_SHARE_TICKET_REQUESTS_PAGE = "SET_SHARE_TICKET_REQUESTS_PAGE";
export const ADD_CUSTOMER_TICKET_HISTORY_PAGE =
  "ADD_CUSTOMER_TICKET_HISTORY_PAGE";
